import styled from 'styled-components';

const StyledAnchor = styled.a`
  position: relative;
  top: -80px;
`;

/**
 * @param {AnchorProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Anchor = ({ anchorName }) => <StyledAnchor id={anchorName} />;

export default Anchor;
